module.exports = __webpack_public_path__ + "img/shield-off.859f46be.svg";